import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-program-committee',
  templateUrl: './program-committee.component.html',
  styleUrls: ['./program-committee.component.css']
})
export class ProgramCommitteeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
